import { ComponentsOverrides, Theme } from '@mui/material';

export const MuiAccordion: {
    styleOverrides: ComponentsOverrides<Theme>['MuiAccordion'];
} = {
    styleOverrides: {
        root: {
            borderBottom: '1px solid',
            borderColor: 'inherit',
            backgroundColor: 'inherit',
            color: 'inherit',
            '&:before': {
                display: 'none',
            },
            '&.Mui-disabled': {
                backgroundColor: 'inherit',
            },
        },
    },
};

export const MuiAccordionSummary: {
    styleOverrides: ComponentsOverrides<Theme>['MuiAccordionSummary'];
} = {
    styleOverrides: {
        root: ({ theme }) => ({
            padding: 0,
            minHeight: 55, // 56px - 1px border from MuiAccordion-root -> box-sizing does not work properly in this case :(
            ...theme.typography.subtitle1,
        }),
        content: ({ theme }) => ({
            display: 'flex',
            gap: theme.spacing(1.5),
            alignItems: 'center',
            margin: 0,
        }),
        expandIconWrapper: ({ theme }) => ({
            color: 'inherit',
            marginRight: theme.spacing(2),
        }),
    },
};

export const MuiAccordionDetails: {
    styleOverrides: ComponentsOverrides<Theme>['MuiAccordionDetails'];
} = {
    styleOverrides: {
        root: ({ theme }) => ({
            padding: 0,
            marginBottom: theme.spacing(3),
            marginRight: theme.spacing(2),
            ...theme.typography.body2,
        }),
    },
};
